import styled from '@emotion/styled'
import {
  DialogContent as MaterialDialogContent,
  DialogActions as MaterialDialogActions,
} from '@material-ui/core'

export const DialogContent = styled(MaterialDialogContent)`
  padding: 0 20px 20px;
`

export const DialogActions = styled(MaterialDialogActions)`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`
